import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Button, Switch } from '@mui/material';
import { Autocomplete, TextField, Typography} from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

export const FinancialProductWarrantiesEditHeaderComponent = ({ canWrite, warranty, onSave, onPropertyChanged, validation, warrantyTypes, quantityTypes }) => {
  const [t] = useTranslation();


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          value={warranty.warrantyTypeId ? { warrantyTypeId: warranty.warrantyTypeId, warrantyTypeName: warranty.warrantyTypeName } : null}
          valueKey='warrantyTypeId'
          labelKey='warrantyTypeName'
          options={warrantyTypes}
          label={t('FinancialProduct.Details.Warranties.WarrantyType')}
          onChange={event => {
            onPropertyChanged('warrantyTypeId', event.warrantyTypeId, 'financialProductWarranty')
            onPropertyChanged('warrantyTypeName', event.warrantyTypeName, 'financialProductWarranty')
          }}
          isSearchable={true}
          error={!isValid(validation.warrantyTypeId)}
          helperText={getErrors(validation.warrantyTypeId)}
          disabled={!canWrite}
          required
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          type='number'
          value={warranty.quantity}
          onChange={event => onPropertyChanged('quantity', event)}
          label={t('FinancialProduct.Details.Warranties.Quantity')}
          error={!isValid(validation.quantity)}
          helperText={getErrors(validation.quantity)}
          disabled={!canWrite}
          required
        />
      </Grid>
      { <Grid item xs={12} sm={4}>

      <Autocomplete
          fullWidth
          value={warranty.quantityTypeId ? { quantityTypeId: warranty.quantityTypeId, quantityTypeName: warranty.quantityTypeName } : null}
          valueKey='quantityTypeId'
          labelKey='quantityTypeName'
          options={quantityTypes}
          label={t('FinancialProduct.Details.Warranties.QuantityType')}
          onChange={event => {
            onPropertyChanged('quantityTypeId', event.quantityTypeId, 'financialProductWarranty')
            onPropertyChanged('quantityTypeName', event.quantityTypeName, 'financialProductWarranty')
          }}
          isSearchable={true}
          error={!isValid(validation.quantityTypeId)}
          helperText={getErrors(validation.quantityTypeId)}
          disabled={!canWrite}
          required
        />
      </Grid> }
      <Grid item xs={12} sm={2}>
          <FormControlLabel
            control={
              <Switch
                checked={warranty.mandatory}
                disabled={!canWrite}
                color='secondary'
                onChange={event => onPropertyChanged('mandatory', event.target.checked)}
                required
              />
            }
            label={<Typography>{t('FinancialProduct.Details.Warranties.Mandatory')}</Typography>}
          />
      </Grid>
      <Grid item xs={12} align='right'>
        <Button
          color='primary'
          variant='contained'
          align='right'
          onClick={onSave}
          disabled={!warranty.changed || !(validation |> isValid) || warranty.saving || !canWrite}
        >
          {warranty.saving ? t('Saving') + '...' : t('Save')}
        </Button>
      </Grid>
    </Grid>
  );
};

FinancialProductWarrantiesEditHeaderComponent.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  warranty: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  warrantyTypes: PropTypes.array.isRequired,
  quantityTypes: PropTypes.array.isRequired
};

export default FinancialProductWarrantiesEditHeaderComponent;
